<template>
    <div class="EmojiSelector">
        <EmojiPicker picker-type="input" @select="onSelectEmoji" disableSkinTones native  />
    </div>
</template>

<script>
import {ref} from "vue";
import EmojiPicker from 'vue3-emoji-picker'

export default {
    name: "EmojiSelector",
    components: {
        EmojiPicker,
    },
    setup(props, {emit}) {
        const input = ref('')
        const onSelectEmoji = (emoji) => {
            emit('input', emoji)
        }

        const showEmoji = () => {

        }

        return {
            onSelectEmoji,
            input
        }
    }
}
</script>

<style lang="scss">
@import "scss/ext/emojiPicker";

</style>
<style lang="scss" scoped>
::v-deep .v3-emoji-picker{
    left: 0 !important;
}

::v-deep .v3-emoji-picker-input{
    width: 40px !important;
    padding: 0 !important;
    border: unset !important;
    text-indent: 9999px;
}
</style>